import _ from 'lodash';
import React, { useEffect, useState, useContext, useRef } from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import PageContainer from "../../container/CustomPage";
import SidebarWrap from "../../container/SidebarDetails";
import ProductDetailsContent from "./Content";
import Loading from "../../components/loading";
import ProductController from '../../controllers/product';
import { GlobalContext } from "../../handlers/GlobalContext";
import {useReactToPrint} from 'react-to-print';
import ErrorHandler from "../../handlers/Error";

const TemplateProductDetailsWithSidebar = ({sidebarPosition}) => {
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    })
    const [ state, dispatch] = useContext(GlobalContext);
    let { id } = useParams();
    const productController = new ProductController();

    const [ initiallyLoaded, setInitiallyLoaded ] = useState(false);
    const [ loading, setLoading] = useState(false);
    const [ product, setProduct ] = useState({});

    useEffect(() => {
        setLoading(true);

        productController.getProduct(id)
            .then((details) => {
                setProduct(details);
                setInitiallyLoaded(initiallyLoaded);
                setLoading(false);
            })
            .catch((err) => {
                ErrorHandler(err,'product-details-fetch',dispatch);
                //if(!!err.code && err.code == 401) dispatch({ type: 'SET_UNAUTHORIZED', payload: {} });
                setLoading(false);
            })
    }, [ initiallyLoaded ])



    return (
        <PageContainer classes={'bg-grey'}>
            <Container ref={componentRef}>
                <Row>
                    <Col xl={9} lg={8} className={`mb-50 ${sidebarPosition === 'left' ? 'order-1 order-lg-2' : ''}`}>
                        <div className='blog-item-details'>
                            <ProductDetailsContent
                                title={product.productName}
                                meta={ _.omit(product,'preparationMedProducts')}
                                methods={product.preparationMedProducts || []}
                            />
                        </div>
                    </Col>

                    <Col xl={3} lg={4} className={`${sidebarPosition === 'left' ? 'order-2 order-lg-1' : ''}`}>
                        <SidebarWrap pid={id} countries={product.medicalProductCountry || [] } attachments={product.productAttachments} methods={{print: handlePrint} }/>
                    </Col>
                </Row>
            </Container>
            {loading ? <Loading/> : null}
        </PageContainer>
    );
};

export default TemplateProductDetailsWithSidebar;